import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Inject, Injector, Directive, Optional, Input, HostListener, NgModule } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/cdk/overlay';
import * as i2 from '@egovsolutions/angular-quick-modal';
import { QuickModalModule } from '@egovsolutions/angular-quick-modal';

class TooltipComponent {
    constructor(tooltipContent) {
        this.tooltipContent = tooltipContent;
    }
}
TooltipComponent.TOOLTIP_CONTENT_INJECTION_TOKEN = 'tooltipContentInjectionToken';
TooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipComponent, deps: [{ token: TooltipComponent.TOOLTIP_CONTENT_INJECTION_TOKEN }], target: i0.ɵɵFactoryTarget.Component });
TooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.2", type: TooltipComponent, selector: "lib-tooltip", ngImport: i0, template: "<div class=\"egov-tooltip\">\n    <div class=\"tooltip-inner\">\n        <ng-container *ngTemplateOutlet=\"tooltipContent\"></ng-container>\n    </div>\n    <div class=\"tooltip-arrow\"></div>\n</div>\n", styles: [".cdk-overlay-container .cdk-overlay-pane.egov-tooltip-container>*{pointer-events:none}.egov-tooltip{position:relative;max-width:42em;color:var(--default-text-color);z-index:1;box-sizing:border-box}.egov-tooltip .tooltip-inner{padding:1.35rem 1.45rem;position:relative;background:#ffffff;border-radius:3px}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-left:1.45rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-left:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-right:1.45rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-right:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-top:1.35rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-top:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-bottom:1.35rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-bottom:5vw}}.egov-tooltip .tooltip-inner:before{content:\"\";position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;border-radius:3px;box-shadow:0 0 20px #000;opacity:.1}.egov-tooltip .tooltip-arrow{position:absolute;z-index:0}.cdk-overlay-pane.direction-top .egov-tooltip{padding-bottom:1.17em}.cdk-overlay-pane.direction-top .egov-tooltip .tooltip-arrow{bottom:calc(.5em + 1px);border:1em solid transparent;border-bottom:none;border-top:.67em solid white}.cdk-overlay-pane.direction-bottom .egov-tooltip{padding-top:1.17em}.cdk-overlay-pane.direction-bottom .egov-tooltip .tooltip-arrow{top:calc(.5em + 1px);border:1em solid transparent;border-top:none;border-bottom:.67em solid white}.cdk-overlay-pane.direction-top.alignment-center .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-center .egov-tooltip .tooltip-arrow{left:50%;margin-left:-1em}.cdk-overlay-pane.direction-top.alignment-start .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-start .egov-tooltip .tooltip-arrow{left:.8em}.cdk-overlay-pane.direction-top.alignment-end .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-end .egov-tooltip .tooltip-arrow{right:.8em}.cdk-overlay-pane.direction-start .egov-tooltip{padding-right:1.17em}.cdk-overlay-pane.direction-start .egov-tooltip .tooltip-arrow{right:calc(.5em + 1px);border:1em solid transparent;border-right:none;border-left:.67em solid white}.cdk-overlay-pane.direction-end .egov-tooltip{padding-left:1.17em}.cdk-overlay-pane.direction-end .egov-tooltip .tooltip-arrow{left:calc(.5em + 1px);border:1em solid transparent;border-left:none;border-right:.67em solid white}.cdk-overlay-pane.direction-start.alignment-center .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-center .egov-tooltip .tooltip-arrow{top:50%;margin-top:-1em}.cdk-overlay-pane.direction-start.alignment-top .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-top .egov-tooltip .tooltip-arrow{top:.8em}.cdk-overlay-pane.direction-start.alignment-bottom .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-bottom .egov-tooltip .tooltip-arrow{bottom:.8em}\n"], directives: [{ type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-tooltip', encapsulation: ViewEncapsulation.None, template: "<div class=\"egov-tooltip\">\n    <div class=\"tooltip-inner\">\n        <ng-container *ngTemplateOutlet=\"tooltipContent\"></ng-container>\n    </div>\n    <div class=\"tooltip-arrow\"></div>\n</div>\n", styles: [".cdk-overlay-container .cdk-overlay-pane.egov-tooltip-container>*{pointer-events:none}.egov-tooltip{position:relative;max-width:42em;color:var(--default-text-color);z-index:1;box-sizing:border-box}.egov-tooltip .tooltip-inner{padding:1.35rem 1.45rem;position:relative;background:#ffffff;border-radius:3px}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-left:1.45rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-left:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-right:1.45rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-right:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-top:1.35rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-top:5vw}}@media (max-width: 960px){.egov-tooltip .tooltip-inner{padding-bottom:1.35rem}}@media (max-width: 600px){.egov-tooltip .tooltip-inner{padding-bottom:5vw}}.egov-tooltip .tooltip-inner:before{content:\"\";position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;border-radius:3px;box-shadow:0 0 20px #000;opacity:.1}.egov-tooltip .tooltip-arrow{position:absolute;z-index:0}.cdk-overlay-pane.direction-top .egov-tooltip{padding-bottom:1.17em}.cdk-overlay-pane.direction-top .egov-tooltip .tooltip-arrow{bottom:calc(.5em + 1px);border:1em solid transparent;border-bottom:none;border-top:.67em solid white}.cdk-overlay-pane.direction-bottom .egov-tooltip{padding-top:1.17em}.cdk-overlay-pane.direction-bottom .egov-tooltip .tooltip-arrow{top:calc(.5em + 1px);border:1em solid transparent;border-top:none;border-bottom:.67em solid white}.cdk-overlay-pane.direction-top.alignment-center .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-center .egov-tooltip .tooltip-arrow{left:50%;margin-left:-1em}.cdk-overlay-pane.direction-top.alignment-start .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-start .egov-tooltip .tooltip-arrow{left:.8em}.cdk-overlay-pane.direction-top.alignment-end .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-bottom.alignment-end .egov-tooltip .tooltip-arrow{right:.8em}.cdk-overlay-pane.direction-start .egov-tooltip{padding-right:1.17em}.cdk-overlay-pane.direction-start .egov-tooltip .tooltip-arrow{right:calc(.5em + 1px);border:1em solid transparent;border-right:none;border-left:.67em solid white}.cdk-overlay-pane.direction-end .egov-tooltip{padding-left:1.17em}.cdk-overlay-pane.direction-end .egov-tooltip .tooltip-arrow{left:calc(.5em + 1px);border:1em solid transparent;border-left:none;border-right:.67em solid white}.cdk-overlay-pane.direction-start.alignment-center .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-center .egov-tooltip .tooltip-arrow{top:50%;margin-top:-1em}.cdk-overlay-pane.direction-start.alignment-top .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-top .egov-tooltip .tooltip-arrow{top:.8em}.cdk-overlay-pane.direction-start.alignment-bottom .egov-tooltip .tooltip-arrow,.cdk-overlay-pane.direction-end.alignment-bottom .egov-tooltip .tooltip-arrow{bottom:.8em}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef, decorators: [{
                    type: Inject,
                    args: [TooltipComponent.TOOLTIP_CONTENT_INJECTION_TOKEN]
                }] }]; } });

class TooltipDirective {
    constructor(el, overlay, injector, quickModal) {
        this.el = el;
        this.overlay = overlay;
        this.injector = injector;
        this.quickModal = quickModal;
        this.openDelay = 200;
        this.closeDelay = 100;
        this.direction = 'top';
        this.xAlignment = 'center';
        this.yAlignment = 'center';
        this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.close = this.close.bind(this);
    }
    // Non-touch devices show a tooltip on hover
    mouseEnterHandler() {
        const isProbablyTouch = window.matchMedia('(hover: none)').matches;
        if (!isProbablyTouch || !this.quickModal) {
            this.openTooltipAfterDelay();
            if (isProbablyTouch)
                console.warn('egovTooltip directive is displaying tooltips instead of dialogs even thought the current device appears to be touch-based because QuickModal hasn\'t been provided. Provide QuickModal to display dialogs instead of tooltips on devices where touch is the primary form of pointing input.');
        }
    }
    openTooltipAfterDelay() {
        this.timeout = window.setTimeout(() => {
            if (this.template) {
                const positionStrategy = this.overlay.position()
                    .flexibleConnectedTo(this.el)
                    .withPositions(this.getPositions())
                    .withFlexibleDimensions(false)
                    // .withViewportMargin(20) // Commented because, for whatever reason, it's not working
                    .withPush(true); // Only happens if none of the positions work
                this.overlayRef = this.overlay.create({
                    panelClass: 'egov-tooltip-container',
                    hasBackdrop: false,
                    disposeOnNavigation: true,
                    positionStrategy,
                    scrollStrategy: this.overlay.scrollStrategies.close(),
                });
                const providers = [
                    { provide: TooltipComponent.TOOLTIP_CONTENT_INJECTION_TOKEN, useValue: this.template }
                ];
                const injector = Injector.create({
                    parent: this.injector,
                    providers
                });
                this.overlayRef.attach(new ComponentPortal(TooltipComponent, undefined, injector));
            }
        }, this.openDelay);
    }
    // Touch devices show a dialog on click
    openDialog() {
        const isProbablyTouch = window.matchMedia('(hover: none)').matches;
        if (this.template)
            if (this.quickModal && isProbablyTouch)
                this.quickModal.show(this.template);
    }
    getPositions() {
        let directions;
        switch (this.direction) {
            case 'top':
                directions = ['top', 'bottom', 'end', 'start'];
                break;
            case 'bottom':
                directions = ['bottom', 'top', 'end', 'start'];
                break;
            case 'start':
                directions = ['start', 'end', 'top', 'bottom'];
                break;
            case 'end':
                directions = ['end', 'start', 'top', 'bottom'];
                break;
        }
        return directions.reduce((reduced, direction) => reduced.concat(this.getPositionsForDirection(direction)), []);
    }
    getPositionsForDirection(direction) {
        switch (direction) {
            case 'top':
            case 'bottom':
                return this.getPositionsForAlignmentX(direction, this.xAlignment);
                break;
            case 'start':
            case 'end':
                return this.getPositionsForAlignmentY(direction, this.yAlignment);
                break;
        }
    }
    getPositionsForAlignmentX(direction, xAlignment) {
        let alignments;
        switch (xAlignment) {
            case 'start':
                alignments = ['start', 'center', 'end'];
                break;
            case 'center':
                alignments = ['center', 'start', 'end'];
                break;
            case 'end':
                alignments = ['end', 'center', 'end'];
                break;
        }
        return alignments.map(alignment => this.generatePosition(direction, alignment));
    }
    getPositionsForAlignmentY(direction, xAlignment) {
        let alignments;
        switch (xAlignment) {
            case 'top':
                alignments = ['top', 'center', 'bottom'];
                break;
            case 'center':
                alignments = ['center', 'top', 'bottom'];
                break;
            case 'bottom':
                alignments = ['bottom', 'center', 'bottom'];
                break;
        }
        return alignments.map(alignment => this.generatePosition(direction, alignment));
    }
    generatePosition(direction, alignment) {
        let originX;
        let originY;
        let overlayX;
        let overlayY;
        const panelClass = [`direction-${direction}`, `alignment-${alignment}`];
        switch (direction) {
            case 'top':
                originY = 'top';
                overlayY = 'bottom';
                break;
            case 'bottom':
                originY = 'bottom';
                overlayY = 'top';
                break;
            case 'start':
                originX = 'start';
                overlayX = 'end';
                break;
            case 'end':
                originX = 'end';
                overlayX = 'start';
                break;
        }
        switch (direction) {
            case 'top':
            case 'bottom':
                originX = overlayX = alignment;
                break;
            case 'start':
            case 'end':
                originY = overlayY = alignment;
                break;
        }
        return { originX, originY, overlayX, overlayY, panelClass };
    }
    close() {
        window.clearTimeout(this.timeout);
        if (!this.closeDelay)
            this.overlayRef?.dispose();
        else
            this.timeout = window.setTimeout(() => this.overlayRef?.dispose(), this.closeDelay);
    }
    ngDestroy() {
        this.close();
    }
}
TooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.Overlay }, { token: i0.Injector }, { token: i2.QuickModal, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
TooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.2", type: TooltipDirective, selector: "[egovTooltip]", inputs: { template: ["egovTooltip", "template"], openDelay: "openDelay", closeDelay: "closeDelay", direction: "direction", xAlignment: "xAlignment", yAlignment: "yAlignment" }, host: { listeners: { "mouseenter": "mouseEnterHandler()", "click": "openDialog()", "mouseleave": "close()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[egovTooltip]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.Overlay }, { type: i0.Injector }, { type: i2.QuickModal, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { template: [{
                type: Input,
                args: ['egovTooltip']
            }], openDelay: [{
                type: Input
            }], closeDelay: [{
                type: Input
            }], direction: [{
                type: Input
            }], xAlignment: [{
                type: Input
            }], yAlignment: [{
                type: Input
            }], mouseEnterHandler: [{
                type: HostListener,
                args: ['mouseenter']
            }], openDialog: [{
                type: HostListener,
                args: ['click']
            }], close: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class TooltipDirectiveModule {
}
TooltipDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TooltipDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirectiveModule, declarations: [TooltipDirective,
        TooltipComponent], imports: [CommonModule,
        QuickModalModule], exports: [TooltipDirective] });
TooltipDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirectiveModule, imports: [[
            CommonModule,
            QuickModalModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: TooltipDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TooltipDirective,
                        TooltipComponent,
                    ],
                    imports: [
                        CommonModule,
                        QuickModalModule,
                    ],
                    exports: [
                        TooltipDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of angular-tooltip-directive
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipDirective, TooltipDirectiveModule };
